import React, { useState, useEffect } from "react";
import { Timeline } from "primereact/timeline";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "./RoadmapComponent.css";

const SmallScreenTimeline = ({ events, themeClass }) => {
  return (
    <div className="small-screen-timeline">
      {events.map((event, index) => (
        <div key={index} className={`event-card ${themeClass}-card animate-fade`}>
          <div className="flex items-center gap-4">
            <div className={`custom-marker ${themeClass}-marker`}>
              {event.icon}
            </div>
            <div>
              <h3 className="event-title">{event.title}</h3>
              <p className="event-description">{event.description}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const Roadmap = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

const phases = [
  {
    title: "Phase 1: Genesis",
    themeClass: "phase1",
    subtitle: "Genesis",
    description:
      "The dawn of the Eon Beasts begins. This phase introduces the NFT generator, empowering users to create unique digital beings. The platform launches with a fair, transparent minting process, ensuring equal opportunity for all early supporters.",
    events: [
      {
        title: "Fair Launch via Pump Fun",
        description:
          "Kickstart the project with a transparent, community-driven launch, offering early incentives to attract the first wave of supporters.",
        icon: "🚀",
      },
      {
        title: "NFT Pre-Sale",
        description:
          "Give early adopters exclusive access to rare NFTs, rewarding the first believers in the Eon Beasts universe.",
        icon: "📢",
      },
      {
        title: "Minting NFTs",
        description:
          "Open the platform for minting unique NFTs, ensuring an accessible and seamless process for collectors.",
        icon: "💎",
      },
      {
        title: "Community Building",
        description:
          "Foster a thriving community across social platforms, engaging users, sharing lore, and gathering feedback to strengthen the ecosystem.",
        icon: "👥",
      },
    ],
  },
  {
    title: "Phase 2: Expansion",
    themeClass: "phase2",
    subtitle: "Expansion",
    description:
      "The Eon Beasts universe grows. A marketplace is launched for trading NFTs, a mobile app is introduced, and the native token is listed to expand reach and liquidity across centralized and decentralized platforms.",
    events: [
      {
        title: "Marketplace Release",
        description:
          "Launch a secure NFT marketplace with trending collections, enabling users to buy, sell, and trade their Eon Beasts.",
        icon: "🛒",
      },
      {
        title: "Mobile App Release",
        description:
          "Deliver a mobile app for iOS and Android, allowing users to explore, mint, and manage their NFTs on the go.",
        icon: "📱",
      },
      {
        title: "Token Listing on CEX & DEX",
        description:
          "List the native token on major exchanges to facilitate trading, increase liquidity, and broaden community access.",
        icon: "💹",
      },
    ],
  },
  {
    title: "Phase 3: Evolution",
    themeClass: "phase3",
    subtitle: "Evolution",
    description:
      "Eon Beasts come to life. Animated NFTs and interactive features provide a dynamic experience, allowing collectors to nurture, play with, and personalize their digital companions using AI Agents.",
    events: [
      {
        title: "Motion Morph Image-to-Spritesheet Release",
        description:
          "Convert static NFTs into animated spritesheets, adding life and motion to each Eon Beast.",
        icon: "🎨",
      },
      {
        title: "GPT Integration",
        description:
          "Integrate GPT-driven AI agents to allow users to talk with their beasts, deepening engagement and personalization.",
        icon: "🤖",
      },
      {
        title: "Metaverse Integration",
        description:
          "Collaborate with metaverse projects, enabling Eon Beasts to exist as avatars, accessories, or interactive assets within virtual worlds.",
        icon: "🌐",
      },
    ],
  },
];


  const renderEventContent = (event, phaseClass) => (
    <div className={`event-card ${phaseClass}-card animate-fade`}>
      <h3 className="event-title">{event.title}</h3>
      <p className="event-description">{event.description}</p>
    </div>
  );

  return (
    <div className="roadmap-container mx-auto py-8">
      <h1 className="roadmap-title text-center mb-8 animate-title-move">Roadmap</h1>

      {/* Custom Tabs Header */}
      <div className="tabs-header">
        {phases.map((phase, index) => (
          <button
            key={index}
            className={`tab-button ${activeIndex === index ? "active" : ""}`}
            onClick={() => setActiveIndex(index)}
          >
            {phase.title}
          </button>
        ))}
      </div>

      {/* Active Tab Content */}
      <div className="tab-content">
        {phases.map(
          (phase, index) =>
            activeIndex === index && (
              <div key={index} className="phase-content flex flex-col gap-8">
                <div className="phase-description bg-white p-6 rounded-lg shadow-lg">
                  <h2 className="phase-subtitle text-2xl lg:text-5xl font-semibold mb-4">
                    {phase.subtitle}
                  </h2>
                  <p className="phase-text text-base lg:text-lg">{phase.description}</p>
                </div>
                <div className="phase-timeline">
                  {isSmallScreen ? (
                    <SmallScreenTimeline events={phase.events} themeClass={phase.themeClass} />
                  ) : (
                    <Timeline
                      value={phase.events}
                      align="alternate"
                      className="custom-timeline"
                      marker={(item) => (
                        <div className={`custom-marker ${phase.themeClass}-marker`}>
                          {item.icon}
                        </div>
                      )}
                      content={(item) => renderEventContent(item, phase.themeClass)}
                    />
                  )}
                </div>
              </div>
            )
        )}
      </div>
    </div>
  );
};

export default Roadmap;